import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getQRById = async (qrId) => {
  return instance.get(`${API}/qr/${qrId}`);
};
